/**
 * Parse a date string from the server as UTC.
 *
 * The Java backend uses LocalDateTime which serializes without a timezone
 * suffix (e.g. "2026-02-06T15:40:42"). JavaScript's Date constructor treats
 * these as local time, but they are actually UTC. This helper appends "Z"
 * when no timezone indicator is present so the date is parsed correctly.
 */
export function parseUTC(dateString: string): Date {
  if (!dateString) return new Date();
  // Already has timezone info (Z, +00:00, -05:00, etc.)
  if (/Z|[+-]\d{2}:\d{2}$/.test(dateString)) {
    return new Date(dateString);
  }
  return new Date(dateString + 'Z');
}
